import { h } from "preact";
import {useEffect} from "preact/hooks";

function TermFilterComponent(props) {

    const cleanPath = window.location.pathname.split("/")[1];

    /**
     * disable event and pass filter
     *
     * @param e
     * @param item
     */
    function handleClick(e, item) {
        e.preventDefault();
        props.updateFilter(item);
    }

    return (
        <div className="glossary_search__letters">
            {
                Object.keys(props.terms).sort().map(item => {
                    return <a href={`/${cleanPath}/${item}`} className={"glossary_search__letter" + (props.filter === item ? ' active' : '')} onClick={(e) => handleClick(e, item)}>
                        {item}
                    </a>
                })
            }
        </div>
    );
}

export default TermFilterComponent;